import React from 'react';
import PropTypes from 'prop-types';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import './grid.scss';

export interface IGrid {
  children?: React.ReactNode;
  childrenRail?: React.ReactNode;
}

const classNames = (): IClassNames =>
  makeClassNames({
    wrapper: 'l-wrapper',
    grid: 'l-grid l-grid--rail-right',
    gridMain: 'l-grid__main',
    innerGrid: 'l-inner-grid',
    innerGridMain: 'l-inner-grid__main',
    gridRail: 'l-grid__rail',
  });

const Grid: React.FC<IGrid> = ({ children, childrenRail }) => {
  const cn = classNames();

  return (
    <div className={cn.wrapper}>
      <div className={cn.grid}>
        <div className={cn.gridMain}>
          <div className={cn.innerGrid}>
            <div className={cn.innerGridMain}>{children}</div>
          </div>
        </div>
        <div className={cn.gridRail}>{childrenRail}</div>
      </div>
    </div>
  );
};

Grid.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  childrenRail: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Grid;
